import { useTranslation } from 'react-i18next';
import { MyProfileTemplate } from '@ideoz/ui';
import { useMyProfile } from './useMyProfile';
import { LanguageSwitcher } from '../../components/LanguageSwitcher';

/**
 * User-account profile module: renders the shared MyProfileTemplate wired to
 * the web logout / auth / startup-sidebar logic in {@link useMyProfile}.
 */
export function MyProfileModule(): JSX.Element {
  const { t } = useTranslation();
  const { user, authDialog, facade } = useMyProfile();

  if (!user) {
    return <div>{t('common.loading')}</div>;
  }

  return (
    <MyProfileTemplate
      facade={facade}
      isWeb
      authDialogState={authDialog}
      languageSwitcher={<LanguageSwitcher />}
    />
  );
}
